import { render, staticRenderFns } from "./PaymentsMX.vue?vue&type=template&id=54ba7718&scoped=true"
import script from "./PaymentsMX.vue?vue&type=script&lang=js"
export * from "./PaymentsMX.vue?vue&type=script&lang=js"
import style0 from "./PaymentsMX.vue?vue&type=style&index=0&id=54ba7718&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ba7718",
  null
  
)

export default component.exports